var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarrerAdverstiment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 68,
    viewBox: "0 0 62 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 37.0833V3.16666L55.6667 15.5L31 27.8333",
    stroke: "#004B6B",
    strokeWidth: 6.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3964 28.5178C59.0372 33.5749 59.1907 38.9969 57.8387 44.1388C56.4867 49.2806 53.6861 53.9258 49.77 57.5218C45.8539 61.1177 40.9873 63.513 35.7491 64.4227C30.5108 65.3324 25.1216 64.7182 20.2224 62.6531C15.3232 60.588 11.1204 57.159 8.11392 52.7741C5.10745 48.3892 3.42392 43.2329 3.26361 37.9187C3.10329 32.6045 4.47295 27.3561 7.20963 22.7979C9.9463 18.2397 13.9348 14.5636 18.7006 12.207",
    stroke: "#004B6B",
    strokeWidth: 6.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6728 27.8241C17.1278 29.8807 16.1219 32.2913 15.7469 34.8362C15.3718 37.381 15.6395 39.9793 16.5256 42.3942C17.4117 44.8091 18.8879 46.964 20.8198 48.6624C22.7518 50.3608 25.078 51.5488 27.5865 52.1182C30.0951 52.6875 32.7062 52.6201 35.1821 51.9221C37.6579 51.2241 39.9197 49.9177 41.7615 48.1219C43.6033 46.3261 44.9664 44.098 45.7267 41.6406C46.487 39.1831 46.6203 36.5745 46.1145 34.0524",
    stroke: "#004B6B",
    strokeWidth: 6.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrerAdverstiment);
export default __webpack_public_path__ + "static/media/carrer-adverstiment.c386f80b5ed201d58dc151ecb0f06717.svg";
export { ForwardRef as ReactComponent };